import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class PreviewService extends ApiBase {
  static blogBaseUrl = getApiUrl(API_URL.PRODUCT, '/blog');

  getArticlePreview(articleAggregationId: string, storeId: string) {
    return this.api.getJSON(`${PreviewService.blogBaseUrl}/articles/preview?articleAggregationId=${articleAggregationId}&storeId=${storeId}`);
  }
}
